import { render, staticRenderFns } from "./CustomImageViewer.vue?vue&type=template&id=a8db26d2&scoped=true&"
import script from "./CustomImageViewer.vue?vue&type=script&lang=js&"
export * from "./CustomImageViewer.vue?vue&type=script&lang=js&"
import style0 from "./CustomImageViewer.vue?vue&type=style&index=0&id=a8db26d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8db26d2",
  null
  
)

export default component.exports